<template lang="pug">
<clip-loader :color="color" :size="size" ></clip-loader>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

export default {
  name: "Loading",
  components: {
    ClipLoader: ClipLoader
  },
  props: {
    color: {
      type: String,
      default: "#53433e"
    },
    size: {
      type: String,
      default: "25vh"
    }
  }
};
</script>

<style lang="sass" scoped>
.v-spinner
  margin: auto
</style>
